import { ColumnDef } from '@tanstack/react-table';

import { PayrunListItem } from '@xemplo/gp-types';

import { PayrunWidgetCell } from './payrun-list-widget-cell';
export const columns: ColumnDef<PayrunListItem>[] = [
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => <PayrunWidgetCell {...row} />,
  },
];
